import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Recognition from '../views/Recognition.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'Home', component: Home },
  { path: '/login', name: 'Login', component: Login },
  { path: '/register', name: 'Register', component: Register },
  { path: '/recognition', name: 'Recognition', component: Recognition }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由守卫：所有页面均可访问，仅登录/注册页做了已登录跳转
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  // 已登录用户访问登录/注册页，直接跳首页
  if (token && ['/login', '/register'].includes(to.path)) {
    next('/home')
  } else {
    next()
  }
})

export default router
